export const mapUserFieldsV2toV1 = (user, tenantCode) => {
    return {
        telephone1: user.telefoneComercial,
        department: user.departamento,
        axt_displayname365: user.nomeParaExibicao,
        firstname: user.nome,
        jobtitle: user.cargo,
        emailaddress1: user.emailPrincipal,
        mobilephone: user.telefoneCelular,
        emailaddress2: user.emailAlternativo,
        lastname: user.sobrenome,
        axt_userprincipalname: user.loginUsuario,
        _axt_servicebundle_value: user._axt_servicebundle_value,
        axt_contact_products: user.axt_contact_products,
        assignedLicenses: user.licencasAtribuidas,
        axt_extensionattribute1: user?.atributosEstendidos?.atributoEstendido1,
        axt_extensionattribute5: user?.atributosEstendidos?.atributoEstendido5,
        axt_extensionattribute8: user?.atributosEstendidos?.atributoEstendido8,
        graphUserId: user.usuarioId,
        tenantCode: tenantCode
    }
}